const IsEmail = require('utils/is-email');

const internals = {};

internals.firstValue = (...values) => values.find((value) => typeof value !== 'undefined' && value !== null && value !== '');
internals.getSchoolById = ({
    schoolId,
    schools = []
} = {}) => schools.find(({ id }) => String(id) === String(schoolId));
internals.getOptionLabel = (option) => option?.name || '';
internals.getOptionValue = (option) => option?.id ?? option?.value ?? option ?? '';
internals.getSelectedSchoolId = ({
    loginContext = {},
    signupContext = {}
} = {}) => internals.firstValue(signupContext.schoolId, loginContext.schoolId);
internals.getSelectedRole = ({
    loginContext = {},
    signupContext = {}
} = {}) => internals.firstValue(signupContext.roleId, loginContext.roleId, 'student');
internals.getSelectedEmail = ({
    loginContext = {},
    signupContext = {}
} = {}) => internals.firstValue(
    loginContext.email,
    loginContext.lastLoginEmail,
    signupContext.email
) || '';
internals.getContextName = ({
    loginContext = {},
    signupContext = {}
} = {}) => {

    const firstLastName = [
        internals.firstValue(signupContext.firstName, loginContext.firstName),
        internals.firstValue(signupContext.lastName, loginContext.lastName)
    ].filter(Boolean).join(' ').trim();

    return internals.firstValue(
        signupContext.name,
        signupContext.fullName,
        loginContext.name,
        loginContext.fullName,
        firstLastName
    ) || '';
};
internals.getSubmitSchoolName = ({
    schools = [],
    values = {}
} = {}) => values.schoolIdText || internals.getSchoolById({
    schoolId: values.schoolId,
    schools
})?.name || '';

internals.buildFields = ({
    isTeamsApp,
    schools = []
} = {}) => ([
    {
        type: 'TextField',
        name: 'email',
        label: 'Email Address',
        rules: {
            validate: (value) => {

                if (!value) {
                    return 'Email is required';
                }

                if (!IsEmail(value)) {
                    return 'Invalid email address';
                }

                return true;
            }
        },
        textFieldProps: {
            id: 'email-input',
            type: 'email'
        }
    },
    {
        type: 'SelectField',
        name: 'role',
        label: 'Your Role',
        options: [
            { value: 'student', label: 'Current Student' },
            { value: 'prospect', label: 'Exploring This School' },
            { value: 'staff', label: 'Staff' },
            { value: 'parent', label: 'Parent' },
            { value: 'other', label: 'Other' }
        ],
        textFieldProps: {
            id: 'role-input'
        }
    },
    {
        type: 'TextField',
        name: 'name',
        label: 'Full Name',
        fullWidth: true,
        rules: {
            validate: (value) => {

                if (!value || !value.match(/\S\s\S/)) {
                    return 'First and Last name is required';
                }

                return true;
            }
        },
        textFieldProps: {
            id: 'name-input'
        }
    },
    {
        type: 'AutocompleteField',
        name: 'schoolId',
        textFieldName: 'schoolIdText',
        label: isTeamsApp ? 'Your Team' : 'Your College or University',
        options: schools,
        exactOptionRequired: true,
        autocompleteErrorText: `You must select ${isTeamsApp ? 'team' : 'college or university'} from the dropdown`,
        getOptionLabel: internals.getOptionLabel,
        getOptionValue: internals.getOptionValue,
        fieldValueFromOption: internals.getOptionValue,
        getSelectedValue: (value) => value,
        rules: {
            validate: (value) => value
                ? true
                : `${isTeamsApp ? 'Team' : 'College or University'} is required`
        }
    },
    {
        type: 'TextareaField',
        name: 'bugDetails',
        label: 'Describe Your Problem',
        rules: {
            validate: (value) => {

                if (!value || value.length < 1) {
                    return 'Description is required';
                }

                return true;
            }
        },
        textFieldProps: {
            id: 'bugDetails',
            placeholder: 'More details help us assist you better',
            maxRows: 4,
            InputProps: {
                'aria-labelledby': 'bugDetails-label'
            }
        }
    }
]);

module.exports.buildFormConfig = function buildFormConfig(props) {

    const {
        defaults,
        formId,
        onSubmit,
        ...fieldOptions
    } = props;

    return {
        defaults,
        fields: internals.buildFields(fieldOptions),
        formId,
        onSubmit
    };
};

module.exports.buildDefaults = function buildDefaults({
    loginContext = {},
    schools = [],
    signupContext = {}
} = {}) {

    const schoolId = internals.getSelectedSchoolId({
        loginContext,
        signupContext
    });
    const selectedSchool = internals.getSchoolById({
        schoolId,
        schools
    });

    return {
        email: internals.getSelectedEmail({
            loginContext,
            signupContext
        }),
        role: internals.getSelectedRole({
            loginContext,
            signupContext
        }),
        name: internals.getContextName({
            loginContext,
            signupContext
        }),
        schoolId: schoolId || '',
        schoolIdText: selectedSchool?.name || '',
        bugDetails: ''
    };
};

module.exports.buildSubmitPayload = function buildSubmitPayload({
    schools = [],
    values = {}
} = {}) {

    return {
        bugType: 'Trouble Logging In',
        bugDetails: {
            description: values.bugDetails,
            role: values.role,
            schoolId: values.schoolId,
            schoolName: values.schoolId ? internals.getSubmitSchoolName({
                schools,
                values
            }) : '',
            deviceType: '',
            browserType: '',
            name: values.name
        },
        email: values.email
    };
};

module.exports.internals = internals;
